import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { STORAGE_URL } from '../services/api';
import {
  Quote,
  ChevronLeft,
  ChevronRight,
  Star,
  ShieldCheck,
  Languages,
  MousePointerClick,
  TrendingUp,
} from 'lucide-react';

// 👇 Yahan se 'testimonials' hata diya, sirf 'whyUs' rakha hai
import { whyUs } from '../mock/mockData';
import ContactSection from "../components/ContactSection";

const whyIcons = [
  ShieldCheck,
  Languages,
  MousePointerClick,
  TrendingUp,
];

const WhyUsAndTestimonials = () => {
  const [index, setIndex] = useState(0);
  
  // 👇 Naye States API ke liye 👇
  const [apiTestimonials, setApiTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  // 👇 API se data fetch karne wala useEffect 👇
  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await api.get("/testimonials");
        // Sirf unhi ko dikhana hai jinka status 1 (Active) hai
        const activeTestimonials = response.data.filter(t => t.status == 1 || t.status === '1');
        setApiTestimonials(activeTestimonials);
      } catch (error) {
        console.error("Error fetching testimonials:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchTestimonials();
  }, []);

  // 👇 Slider ka auto-play logic ab API data ke hisaab se chalega 👇
  useEffect(() => {
    if (apiTestimonials.length === 0) return; // Agar data nahi aaya toh slider mat chalao

    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % apiTestimonials.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [apiTestimonials.length]);

  const prev = () => {
    if (apiTestimonials.length === 0) return;
    setIndex((prev) => (prev - 1 + apiTestimonials.length) % apiTestimonials.length);
  };

  const next = () => {
    if (apiTestimonials.length === 0) return;
    setIndex((prev) => (prev + 1) % apiTestimonials.length);
  };

  return (
    <>
      {/* WHY CHOOSE US */}
      <section className="py-14 bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
        <div className="max-w-[1200px] mx-auto px-4">
          <div className="text-center mb-10">
            <div className="inline-block text-3xl font-bold uppercase tracking-widest text-[#FED547] mb-2">
              Why Choose Us
            </div>
            <h2 className="text-xl font-extrabold text-gray-900 dark:text-white">
              Why Kadtech HR Solutions?
            </h2>
            <p className="text-gray-600 dark:text-gray-300 mt-2 max-w-2xl mx-auto text-sm">
              India's most trusted platform for entry-level and blue-collar hiring, connecting millions of job seekers with verified employers.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {whyUs.map((w, i) => {
              const Icon = whyIcons[i];
              return (
                <div
                  key={i}
                  className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 p-6 hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
                >
                  <div className="w-12 h-12 rounded-lg bg-orange-100 flex items-center justify-center mb-4">
                    <Icon className="w-6 h-6 text-[#FED547]" />
                  </div>
                  <h3 className="font-bold text-gray-900 dark:text-white mb-1">{w.title}</h3>
                  <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">{w.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-16 bg-white dark:bg-gray-900 transition-colors duration-300">
        <div className="max-w-[1200px] mx-auto px-4">
          <div className="text-center mb-10">
            <div className="inline-block text-3xl font-bold uppercase tracking-widest text-[#FED547] mb-2">
              Testimonials
            </div>
            <h2 className="text-xl font-extrabold text-gray-900 dark:text-white">
              Stories from our associates
            </h2>
          </div>

          <div className="max-w-4xl mx-auto relative">
            {/* 👇 Loading aur Empty state add ki hai 👇 */}
            {loading ? (
              <div className="text-center py-10 text-gray-500">Loading testimonials...</div>
            ) : apiTestimonials.length === 0 ? (
              <div className="text-center py-10 text-gray-500">No testimonials found yet.</div>
            ) : (
              <>
                <div className="bg-gradient-to-br from-orange-50 to-white dark:from-gray-800 dark:to-gray-900 rounded-2xl border border-orange-100 dark:border-gray-700 p-8 md:p-12 shadow-sm transition-colors duration-300">
                  <Quote className="w-10 h-10 text-[#FED547]/30 mb-4" />

                  {/* Field Name 'text' ko 'message' kiya */}
                  <p className="text-gray-700 dark:text-gray-300 leading-relaxed text-[15px] md:text-base min-h-[120px]">
                    {apiTestimonials[index].message}
                  </p>

                  <div className="flex items-center gap-4 mt-6">
                    {apiTestimonials[index].image ? (
                      <img
                        src={STORAGE_URL(apiTestimonials[index].image)}
                        alt={apiTestimonials[index].name}
                        className="w-14 h-14 rounded-full border-2 border-[#FED547] bg-white dark:bg-gray-800 object-cover"
                      />
                    ) : (
                      <div className="w-14 h-14 rounded-full border-2 border-[#FED547] bg-[#FED547] flex items-center justify-center text-lg font-bold text-black">
                        {apiTestimonials[index].name ? apiTestimonials[index].name.charAt(0).toUpperCase() : 'T'}
                      </div>
                    )}

                    <div>
                      <div className="font-bold text-gray-900 dark:text-white">- {apiTestimonials[index].name}</div>
                      {/* Field Name 'role' ko 'designation' kiya */}
                      <div className="text-xs text-gray-500 dark:text-gray-400">{apiTestimonials[index].designation}</div>

                      <div className="flex gap-0.5 mt-1">
                        {/* Database ke rating ke hisaab se stars dikhayega, default 5 */}
                        {[...Array(apiTestimonials[index].rating || 5)].map((_, s) => (
                          <Star key={s} className="w-3 h-3 fill-yellow-400 text-yellow-400" />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                <button
                  onClick={prev}
                  className="absolute left-0 md:-left-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 shadow-md hover:bg-[#FED547] hover:text-white transition-colors flex items-center justify-center"
                >
                  <ChevronLeft className="w-5 h-5" />
                </button>

                <button
                  onClick={next}
                  className="absolute right-0 md:-right-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 shadow-md hover:bg-[#FED547] hover:text-white transition-colors flex items-center justify-center"
                >
                  <ChevronRight className="w-5 h-5" />
                </button>

                <div className="flex justify-center gap-2 mt-6">
                  {apiTestimonials.map((_, i) => (
                    <button
                      key={i}
                      onClick={() => setIndex(i)}
                      className={`h-2 rounded-full transition-all ${
                        i === index
                          ? 'w-8 bg-[#FED547]'
                          : 'w-2 bg-gray-300 dark:bg-gray-700 hover:bg-gray-400 dark:hover:bg-gray-600'
                      }`}
                    />
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </section>

      {/* CONTACT SECTION */}
      <ContactSection />
    </>
  );
};

export default WhyUsAndTestimonials;